/**
 * KVKK in-app consent text.
 * Boilerplate Turkish KVKK aydınlatma metni for B2B (doctors).
 * Super admin can edit later via settings (TODO).
 */
export const KVKK_TEXT_DOCTOR = `KİŞİSEL VERİLERİN KORUNMASI HAKKINDA AYDINLATMA METNİ

NeoBreed AI olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu sıfatıyla, kişisel verilerinizin güvenliğine önem veriyoruz.

1. İşlenen Kişisel Veriler
- Kimlik bilgileri (ad, soyad), iletişim bilgileri (e-posta, telefon)
- Mesleki bilgiler (klinik adı, uzmanlık alanı)
- İşlem güvenliği bilgileri (giriş kayıtları, IP)
- Hasta dosyalarına bağlı sağlık verileri (yalnızca tarafınızca yüklenen)

2. İşleme Amaçları
- Hizmet sağlama, hesap yönetimi, kimlik doğrulama
- Yasal yükümlülüklerin yerine getirilmesi
- Hizmet kalitesinin iyileştirilmesi ve güvenliğin sağlanması

3. Aktarım
Kişisel verileriniz; mevzuatın izin verdiği ölçüde, yetkili kamu kurumları, hizmet aldığımız bulut altyapı sağlayıcılarımız ve iş ortaklarımızla paylaşılabilir. Yurt dışına aktarım yapılması halinde KVKK m.9 kapsamında gerekli güvenceler sağlanır.

4. Haklarınız
KVKK m.11 uyarınca; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, düzeltilmesini veya silinmesini isteme, üçüncü kişilere bildirilmesini talep etme, zarara uğramanız halinde tazminat talep etme haklarına sahipsiniz.

5. İletişim
KVKK'dan doğan haklarınızı kullanmak için info@neobreedai.com adresine başvurabilirsiniz.

İşbu metni okuduğumu, anladığımı ve kişisel verilerimin yukarıda belirtilen şekilde işlenmesine onay verdiğimi beyan ederim.`;
